// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__3ljTn","ThumbZoom":"ChapterPlayer_ThumbZoom__3_sfG"};